import { createSelector } from 'reselect';
import trim from 'lodash/trim';
import last from 'lodash/last';
import { getQuery } from './querySelectors';

export const getCountry = createSelector(getQuery, ({ location }) => trim(last((location || '').split(','))) || null);
